<template>
  <div class="acc-photo-index">
    <Search ref="search" :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="100" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #storeName="{ row }">{{ row.storeName || '---' }}</template>
      <template #ticketPicUrl="{ row }">
        <img class="url" :src="row.ticketPicUrl" alt="" srcset="">
      </template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #ticketNo="{ row }">{{ row.ticketNo ? row.ticketNo : '---' }}</template>
      <template #consume="{ row }">{{ row.consume ? $moment(row.consume).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #amount="{ row }">{{ row.amount ? row.amount : '---' }}</template>
      <template #tradeNo="{ row }">{{ row.tradeNo ? row.tradeNo : '---' }}</template>
      <template #memberPoint="{ row }">{{ row.memberPoint ? row.memberPoint : '---' }}</template>
      <template #status="{ row }">
        <span :class="row.status + ' status'"></span>
        {{formatStatus(row.status)}}
      </template>
      <template #operatorName="{ row }">{{ row.operatorName ? row.operatorName : '---' }}</template>
      <template #examined="{ row }">{{ row.examined ? $moment(row.examined).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #rejectReason="{ row }">{{ row.rejectReason ? row.rejectReason : '---' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
      <template #operation="{ scope }">
        <auth-button auth="member:point:apply:examine">
          <el-button v-if="scope.row.status === 'New'" type="text" @click="onApply(scope.row)">审核</el-button>
        </auth-button>
      </template>
    </Table>
    <Dialog :maskClose="false" :dialogShow="DialogShow" title="审核" @maskClick="() => {DialogShow = false}">
      <template>
        <div class="apply">
          <el-form :hide-required-asterisk="true" ref="applyForm" :model="applyForm" label-width="100px">
            <el-form-item label="小票数据">
              <img :src="checkRow.ticketPicUrl" class="ticketPicUrl" @click="lookBigImg(checkRow.ticketPicUrl)">
            </el-form-item>
            <el-form-item label="审核结果">
              <el-radio-group v-model="applyType" @change="changeApplyType">
                <el-radio label="Passed">通过</el-radio>
                <el-radio label="Reject">拒绝</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="applyType === 'Passed'">
              <el-form-item label="消费店铺" prop="storeId" :rules="[{ required: true, message: '请选择消费店铺'},]" >
                <el-cascader
                  v-model="applyForm.storeId"
                  placeholder="请选择店铺"
                  :options="shopTreeData"
                  filterable
                  :props="shopCascaderProps"
                  clearable
                  :show-all-levels="false"
                  @change="computeGivePoint"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item :rules="[{ required: true, message: '请输入小票编号'},]" label="小票编号" prop="ticketNo">
                <el-input placeholder="请输入小票编号" v-model="applyForm.ticketNo" type="text"></el-input>
              </el-form-item>
              <el-form-item :rules="[{ required: true, message: '请输入消费时间'},]" label="消费时间" prop="consume">
                <el-date-picker
                  v-model="applyForm.consume"
                  type="datetime"
                  placeholder="选择消费时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item :rules="[{ required: true, message: '请输入消费金额'},]" label="消费金额"  prop="amount">
                <el-input placeholder="请输入消费金额" v-model="applyForm.amount" @blur="computeGivePoint" type="text"></el-input>
              </el-form-item>
              <el-form-item :rules="[{ required: true, message: '请输入交易流水号'},]" label="交易流水号"  prop="tradeNo">
                <el-input placeholder="请输入交易流水号" v-model="applyForm.tradeNo" type="text"></el-input>
              </el-form-item>
              <el-form-item label="可赠送积分">
                <span v-if="!applyForm.storeId || !applyForm.amount">根据消费金额和积分规则自动计算积分</span>
                <span v-else>{{computeResult}}</span>
              </el-form-item>
            </div>
            <div v-if="applyType !== 'Passed'">
              <el-form-item :rules="[{ required: true, message: '请输入拒绝原因'},]" label="拒绝原因" prop="rejectReason">
                <el-input type="textarea" rows="6" v-model="applyForm.rejectReason" placeholder="请输入拒绝原因"/>
              </el-form-item>
            </div>
          </el-form>
          <div class="dialog-button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => {DialogShow = false}">取消</el-button>
              <el-button type="primary" :loading="DialogLoading" class="determine" @click="determine">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
import { api_getPointApplyList, api_postComputeGivePoint, api_putPointCheck, api_postPhotograpListExport } from '@/api/integral'
import { api_getConfig, api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
import { downFile } from "@/utils";

export default {
  name: "accFlowIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      tableKey: false,
      exportLoading: false,
      renderData: [
        {
          label: "审核状态",
          placeholder: "请选择审核状态",
          type: "select",
          multiple: false,
          key: "status",
          option: [{
            label: '已通过',
            value: 'Passed'
          },{
            label: '待审核',
            value: 'New'
          },{
            label: '已拒绝',
            value: 'Reject'
          }],
        },
        {
          label: "上报时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "created",
          valueFormat: 'timestamp',
        },
        {
          label: "消费时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "consume",
          valueFormat: 'timestamp',
        },
        {
          label: "商场名称",
          placeholder: "请选择商场名称",
          type: "select",
          multiple: false,
          key: "mallId",
          option: [],
        },
        {
          label: "消费店铺",
          placeholder: "请选择消费店铺",
          type: "choose-store",
          key: "storeId",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
          maxLength: 11,
        },
        {
          label: "小票编号",
          placeholder: "请输入小票编号",
          type: "input",
          key: "ticketNo",
        },
        {
          label: "订单来源",
          placeholder: "请选择订单来源",
          type: "select",
          multiple: false,
          key: "source",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        }
      ],
      form: {
        status: 'New'
      },
      tableThData: [
        { prop: "created", label: "上报时间", minWidth: "180", },
        { prop: "storeName", label: "消费店铺", minWidth: "180", },
        { prop: "mallName", label: "商场", minWidth: "180", },
        { prop: "ticketPicUrl", label: "小票图片", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "ticketNo", label: "小票编号", minWidth: "180", },
        { prop: "consume", label: "消费时间", minWidth: "180", },
        { prop: "amount", label: "消费金额", minWidth: "100", },
        { prop: "tradeNo", label: "交易流水号", minWidth: "180", },
        { prop: "memberPoint", label: "积分变动", minWidth: "180", },
        { prop: "status", label: "状态", minWidth: "180", },
        { prop: "operatorName", label: "审核人", minWidth: "180", },
        { prop: "examined", label: "审核时间", minWidth: "180", },
        { prop: "rejectReason", label: "拒绝原因", minWidth: "180", },
        { prop: "source", label: "订单来源", minWidth: "180", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ],
      DialogShow: false,
      DialogLoading: false,
      applyForm: {
        ticketNo: '',
        consume: '',
        amount: '',
        tradeNo: '',
        rejectReason: '',
        storeId: ''
      },
      applyType: 'Passed',
      checkRow: {},
      shopTreeData: [], // 店铺级联框树形数据
      shopCascaderProps: {
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项
      computeResult: '', // 计算结果
    };
  },
  created () {
    this.getMallList(),
    this.getShopTreeData() // 获取店铺级联框数据
  },
  methods: {
    // 查看大图
    lookBigImg (src) {
      const image = new Image()
      image.src = src
      image.onload = () => {
        image.style.margin = "0 auto"
        image.style.display = "block"
        const newWin = window.open("", "_blank")
        newWin.document.write(image.outerHTML)
      }
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      let newParams = {...params}

      if(newParams.created && newParams.created.length > 0){
        newParams.applyStartTime = newParams.created[0] * 1
        newParams.applyEndTime = newParams.created[1] * 1
      }
      delete newParams.created
      if(newParams.consume && newParams.consume.length > 0){
        newParams.consumeStartTime = newParams.consume[0] * 1
        newParams.consumeEndTime = newParams.consume[1] * 1
      }
      delete newParams.consume

      // // 处理店铺数据
      // if (newParams.storeIds) {
      //   newParams.storeIds = '[' + newParams.storeIds.join(',') + ']'
      // }
      this.$router.push({query: params})
      try {
        const data = await api_getPointApplyList(newParams)
        console.log('data: ', data);
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    // 获取商场数据
    async getMallList() {
      let res = await api_getConfig('mall')
      let arr = res.mall.map(item => {
        return {
          label: item.name,
          value: item.id + ''
        }
      })
      this.renderData[3].option = arr
    },

    // 获取店铺级联框数据
    async getShopTreeData() {
      const {storeThreeLevel=[]} = await api_getConfig('storeThreeLevel')
      this.shopTreeData = storeThreeLevel // 店铺级联框数据
    },

    // 点击审核按钮
    onApply(row) {
      this.DialogShow = true
      this.applyType = 'Passed'
      setTimeout(() => {
        this.$refs.applyForm.resetFields()
      }, 100)
      this.checkRow = row
      this.computeResult = ''
      let {id, tenantId, storeId='' } = row
      this.applyForm = {
        id,
        tenantId,
        ticketNo: '',
        consume: '',
        amount: '',
        tradeNo: '',
        rejectReason: '',
        storeId: storeId + ''
      }
    },
    // 审核确定
    determine () {
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          if (typeof this.computeResult !== 'number' && this.applyType == 'Passed') {
            this.$baseMessage(this.computeResult, 'warning')
            return
          }
          this.DialogLoading = true
          this.applyForm.consume = +new Date(this.applyForm.consume)
          this.applyForm.status = this.applyType
          try {
            await api_putPointCheck({...this.applyForm})
            this.DialogLoading = false
            this.DialogShow = false
            this.$baseMessage('操作成功', 'success')
            this.getList()
          } catch (error) {
            this.DialogLoading = false
          }
        } else {
          return false
        }
      })
    },
    formatStatus (status) {
      switch (status) {
        case 'Passed':
          return '已通过'
        case 'New':
          return '待审核'
        case 'Reject':
          return '已拒绝'
      }
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      let newParams = {...this.form}
      if(newParams.created && newParams.created.length > 0){
        newParams.applyStartTime = newParams.created[0] * 1
        newParams.applyEndTime = newParams.created[1] * 1
      }
      delete newParams.created
      if(newParams.consume && newParams.consume.length > 0){
        newParams.consumeStartTime = newParams.consume[0] * 1
        newParams.consumeEndTime = newParams.consume[1] * 1
      }
      delete newParams.consume
      let res = await api_postPhotograpListExport(newParams)
      downFile(res)
      this.exportLoading = false
    },

    // 计算可赠送积分
    async computeGivePoint() {
      const { id, storeId, amount } = this.applyForm
      if (id && storeId && amount) {
        const {data} = await api_postComputeGivePoint({id, storeId, amount})
        this.computeResult = data
      }
    },

    changeApplyType () {
      this.$refs.applyForm.resetFields()
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.acc-photo-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .look-phone-btn {
    font-size: 10px;
    color: #1A5CF5;
    margin-left: 5px;
  }

  .url{
    width: 120px;
    height: 56px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .Passed{
    background: #05c8af;
  }
  .New{
    background: #1A5CF5;
  }
  .Reject{
    background: #F74A4A;
  }
  .dialog-button-div{
    overflow: hidden;
    float: right;
    margin-top: 33px;
    button{
      border: 0;
      width: 110px;
      height: 40px;
      border-radius: 2px;
      font-size: 16px;
    }
    .cancel{
      background: #F2F3F5;
      color: #666666;
    }
  }

  .fun-btn-box {
    margin-top: 20px;
  }
  .el-button {
    min-width: 80px !important;
  }

  .ticketPicUrl{
    width: 150px;
    height: 150px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
    cursor: pointer;
  }
  ::v-deep{
    .content{
      .title{
        margin-bottom: 20px;
      }

      .el-cascader,
      .el-input{
        width: 100%;
      }
    }
  }
}
</style>
